import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableFreightExport = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableFreightExport);
};
